import {Component, computed, input, output} from '@angular/core';
import {EventItem} from "../../../common/interfaces";
import {DotButtonComponent} from "../dot-button/dot-button.component";
import {MatButtonModule} from "@angular/material/button";
import {MatCardModule} from "@angular/material/card";
import {TranslatePipe} from "@ngx-translate/core";
import {MatIconModule} from "@angular/material/icon";
import {NewSingleEventComponent} from "../new-single-event/new-single-event.component";

@Component({
  selector: 'app-new-all-events',
  standalone: true,
  imports: [MatCardModule, TranslatePipe, MatIconModule, MatButtonModule, DotButtonComponent, NewSingleEventComponent],
  templateUrl: './new-all-events.component.html',
  styleUrl: './new-all-events.component.sass'
})
export class NewAllEventsComponent {
  readonly title = input<string>('');
  readonly eventsList = input<EventItem[]>([]);
  readonly selectEvent = output<EventItem>();

  currentPage = 0;

  readonly itemsPerPage = 4;
  readonly totalPages = computed(() => Math.ceil(this.eventsList().length / this.itemsPerPage) || 1);

  readonly pageIndices = computed(() => Array.from({ length: this.totalPages() }, (_, i) => i));

  handleChangePage = (page: number): void => {
    this.currentPage = page;
  };

  goToEventPage(event: EventItem): void {
    localStorage.setItem('selectedEvent', JSON.stringify(event));
    this.selectEvent.emit(event);
  }
}
